export const gs8_foods = [
    {
        "name": "Sardines",
        "appearances": 1,
        "rank": 16,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/sards.png",
        "description": "A surprise and controversial selection, Sardine fans will have their chance to show if they have a future on the bracket, while this will serve as a nice warm-up for #1 Pickles and the big green bandwagon."
    },
    {
        "name": "Hard Boiled Eggs",
        "appearances": 3,
        "rank": 15,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/hbe.png",
        "description": "Not a stranger to being a 15-seed, HBE has been here before, knocking off #2 Toaster Strudels in a stunning upset back in 2022. Can they capture the magic once again after last years's disappointing loss to Twinkies in the opening round?"
    },
    {
        "name": "Spaghetti & Meatballs",
        "appearances": 3,
        "rank": 14,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/spaghetti.png",
        "description": "It would be the first true 'combo item' served at Gullet Stuffer, but Spaghetti & Meatballs has struggled in two previous attempts to reach the Elite Eight. With nominations to back it, 'S&M' are back for one more try..."
    },
    {
        "name": "Corn",
        "appearances": 4,
        "rank": 13,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/corn.png",
        "description": "Another familiar face, 'iTs CoRn!' is a classic competition food that seeks to find footing with voters. It will be another tough first round showdown against #4 Uncrustables in 2026."
    },
    {
        "name": "Sugar Cookies",
        "appearances": 1,
        "rank": 12,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/sugarcookies.png",
        "description": "A new nominee, the humble grocery store sugar cookie has been known to dry out a few mouths in its heyday. It would have to be the ones with the pink frosting, right?"
    },
    {
        "name": "Spicy Buldak Ramen",
        "appearances": 4,
        "rank": 11,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/buldak.png",
        "description": "After a decent showing against Pie last year, new-look Spicy Buldak Ramen looks to find the kind of support that once made it a Final Four candidate. An early victory could set up a quarterfinal showdown with #3 Ice Cream Sandwiches.."
    },
    {
        "name": "Tater Tots",
        "appearances": 2,
        "rank": 10,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/tots.png",
        "description": "After receiving strong fan feedback during nominations, 'Double T' returns to the 2026 Bracket after a year off, plenty of time to think about their 2024 loss to Corn Dogs… It's an exciting first round matchup against #7 Musubis that could go down to the wire!"
    },
    {
        "name": "Empanadas",
        "appearances": 1,
        "rank": 9,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/empanada.png",
        "description": "Young, fresh and ready to go, 'Empa Enthusiasts' are excited to do battle with #8 Crab Rangoon in one of the most anticipated matchups of the 2026 first round. #1 Pickles looms over the winner however…"
    },
    {
        "name": "Crab Rangoon",
        "appearances": 1,
        "rank": 8,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/rangoon.png",
        "description": "Those who get it, get it! Crab Rangoon's cult following could spread into the mainstream of Gullet Stuffer voters, creating a ripple effect that could test the boundaries of both space and time… Rangoons vs. Pickles could get very interesting in Round 2."
    },
    {
        "name": "Musubis",
        "appearances": 1,
        "rank": 7,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/musubi.png",
        "description": "The highest ranked rookie of 2026, the humble musubi has been a staple of Gullet Stuffer events since 2022, handmade and sold by Robeil of 24th Ave Sauce. He'll need some help if this first time candidate were to shock the world and win it all…"
    },
    {
        "name": "Twinkies",
        "appearances": 2,
        "rank": 6,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/twink.png",
        "description": "A big first round upset against Hard Boiled Eggs last year puts this sweet treat in position for a possible rematch against Ice Cream Sandwiches in the Quarterfinals. “I'm a Twinkie in a Ding Dong world…♫♬”"
    },
    {
        "name": "Churros",
        "appearances": 2,
        "rank": 5,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/churros.png",
        "description": "After strong showing in 2025, losing to eventual champion Gyoza in the quarters, the path to a Final Four looks much easier this time around for these sugary sticks of goodness. "
    },
    {
        "name": "Uncrustables",
        "appearances": 3,
        "rank": 4,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/crustable.png",
        "description": "What the crust?? Continuing to rise in voter popularity, a likely matchup with #5 Churros could provide the momentum needed to have a chance vs. #1 Pickles in a Final Four Matchup…"
    },
    {
        "name": "Ice Cream Sandwiches",
        "appearances": 5,
        "rank": 3,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/icecream.png",
        "description": "A semifinalist one year ago, ICS is an interesting candidate; lots of votes but historically not many vocal supporters. Will they emerge to make a serious title run this time around?"
    },
    {
        "name": "Pie",
        "appearances": 4,
        "rank": 2,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/pie.png",
        "description": "Back once again, Pie has a new 'mystery' look this year, as many are speculating about the possibilities if this two-seed can capture the same magic that Gyoza did last year from the same spot in the bracket. Pie… ?"
    },
    {
        "name": "Pickles",
        "appearances": 4,
        "rank": 1,
        "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS8/pickle.png",
        "description": "What else can be said about the most dominant runner-up in modern history? Back to back finals appearances, back to back shocking losses. Now they stand alone at the top once again… Can anyone stand up to challenge them? Or is it finally the Year of the Pickle?"
    }
]